import { isFunction } from 'lodash';
import { useCallback, useRef, useState } from 'react';

export const useRefState = <T>(initialValue: T) => {
    const [state, setState] = useState<T>(initialValue);
    const ref = useRef(initialValue);

    /**
     * because of the async behaviour of setState the ref is not reliably updated after calling setState
     * when you want to perform an action that depends on ref to be up to date, use the onRefSet callback
     */
    const handleSetState = useCallback(
        (value: T | ((prev: T) => T), onRefSet?: () => void) => {
            if (isFunction(value)) {
                setState(prev => {
                    const newState = value(prev);
                    ref.current = newState;
                    onRefSet?.();
                    return newState;
                });
            } else {
                setState(() => {
                    ref.current = value;
                    onRefSet?.();
                    return value;
                });
            }
        },
        [],
    );

    return [state, handleSetState, ref] as const;
};
